// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M21 6.58594V23H3V1H15.4141L21 6.58594ZM7 11V20H9V13H11V20H13V13H15V20H17V12.5713C16.9999 11.7035 16.2965 11.0001 15.4287 11H7ZM14.5 7.5H19L14.5 3V7.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-markdown-filled')
export default class FileMarkdownFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-markdown-filled',
    }
  }
}
